import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import VideoConference from '../VideoConference';

import theme from './VideoLayoutManager.scss';

const propTypes = {
  switched: PropTypes.bool.isRequired,
  localVideoConnected: PropTypes.bool.isRequired,
  remoteVideoConnected: PropTypes.bool.isRequired,
  setVideoLayout: PropTypes.func.isRequired,
};

class VideoLayoutManager extends Component {

  static propTypes = propTypes;

  toggle = () => {
    const { remoteVideoConnected, localVideoConnected, setVideoLayout, switched } = this.props;

    if (remoteVideoConnected && localVideoConnected) {
      setVideoLayout(!switched);
    }
  };

  render() {
    const { switched } = this.props;

    return (
      <div className={ classnames(theme.root, { [theme.switched]: switched }) }>
        <VideoConference />
      </div>
    );
  }
}

export default VideoLayoutManager;
